import React from 'react';
import classNames from 'classnames';

export const HintTextTW: React.FC<{ hintText?: string; disabled?: boolean; className?: string }> = ({
  hintText,
  disabled,
  className,
}) => {
  if (hintText === undefined) {
    return null;
  }

  const utilityClassName = classNames(`text-sm ${disabled ? 'text-gray-100' : 'text-gray-500'}`, className);
  return (
    <p className={utilityClassName} role={'paragraph'}>
      {hintText}
    </p>
  );
};
